import React, { ComponentType, ReactNode } from 'react'
import { Header, headerDimension } from 'src/layout/header/Header'
import { css } from 'src/ui/style/css'
import { Theme } from 'src/ui/style/Theme'
import { ReturnToOrderButton } from 'src/business/ordering/ReturnToOrderButton'
import { Footer } from 'src/layout/footer/Footer'
import { AppHelmet } from 'src/meta/AppHelmet'
import { mediaMaxWidth } from 'src/ui/style/mixins/helpers'
import { CatchError } from 'src/error/CatchError'
import { ErrorMain } from 'src/error/ErrorMain'
import { useIsQrCodeAccessPage } from '../hooks/useIsQrCodeAccessPage'
import { CookieBar } from '../ui/cookie-bar/CookieBar'

export type AppLayoutProps = {
    children: ReactNode
}
export const AppLayout: ComponentType<AppLayoutProps> = ({ children }) => {
    const isQrCodeAccessPage = useIsQrCodeAccessPage()

    // Special layout for QR Access page
    if (isQrCodeAccessPage) {
        return <>{children}</>
    }

    return (
        <div>
            <AppHelmet />
            <CatchError>
                <Header />
            </CatchError>
            <CatchError renderError={() => <ErrorMain />}>
                <main
                    css={(th: Theme) => css`
                        // Keep footer out of viewport while async content hydrates,
                        // reducing large footer shifts on data-heavy pages.
                        min-height: calc(
                            100vh - ${headerDimension.desktopHeight}
                        );
                        background: ${th.colors.background};
                        ${mediaMaxWidth(th.screens.sm)} {
                            min-height: calc(
                                100vh - ${headerDimension.mobileHeight}
                            );
                        }
                    `}
                >
                    {children}
                </main>
            </CatchError>
            <CatchError>
                <Footer />
                <CookieBar />
                {/* Has to be here because of mobile sticky behaviour */}
                <ReturnToOrderButton />
            </CatchError>
        </div>
    )
}
